import React from "react";
import { Component } from "react";
import { IntlShape } from "react-intl";
import { ColumnDefinition, RowDefinition, components } from "griddle-react";
import { Map } from "immutable";

import { Api } from "@api/index";
import { Locale } from "@localisation/models";
import { Table } from "@ui/Table";
import { CellDateTime, CellRelated, CellActions } from "@ui/Table/Cells";
import { messages as uiMessages } from "@ui/messages";
import { User as Model, Organisation, Role } from "../../models";
import { messages } from "../../messages";

interface UserTableProps {
    users: Map<number, Model>;
    organisations: Map<number, Organisation>;
    roles: Map<string, Role>;
    intl: IntlShape;
    userId: number;
    canUpdateUser: boolean;
    canDeleteUser: boolean;
    locale: Locale;
}

// Type the table component
type TypedTable = new () => Table<Model>;
const TypedTable = Table as TypedTable;

class UserTable extends Component<UserTableProps, any> {
    private Actions: React.FC<components.CellProps> = null;

    private userCanDelete(id: number) {
        return this.props.canDeleteUser && id !== this.props.userId;
    }

    public componentWillMount() {
        const { formatMessage } = this.props.intl;
        // Setup the actions component
        this.Actions = CellActions(formatMessage(messages.userEntityDemonstrative),
            "/users/edit/", "name", Api.usersDestroy, this.props.canUpdateUser,
            this.userCanDelete.bind(this));
    }

    public render(): JSX.Element {
        const { formatMessage } = this.props.intl;
        const { users, organisations, roles, locale } = this.props;

        // TODO Normalise the users.

        return (
            <TypedTable data={users.toArray()} defaultSorting={{ id: "createdAt", sortAscending: true }}>
                <RowDefinition>
                    <ColumnDefinition
                        id="name"
                        title={formatMessage(messages.userColumnName)} />
                    <ColumnDefinition
                        id="email"
                        title={formatMessage(messages.userColumnEmail)} />
                    <ColumnDefinition
                        id="organisation"
                        title={formatMessage(messages.userColumnOrganisation)}
                        customComponent={CellRelated(organisations, "name", locale)} />
                    <ColumnDefinition
                        id="roles"
                        title={formatMessage(messages.userColumnRoles)}
                        customComponent={CellRelated(roles, "label", locale)} />
                    <ColumnDefinition
                        id="createdAt"
                        title={formatMessage(messages.userColumnCreatedAt)}
                        customComponent={CellDateTime} />
                    <ColumnDefinition
                        id="updatedAt"
                        title={formatMessage(messages.userColumnUpdatedAt)}
                        customComponent={CellDateTime} />
                    <ColumnDefinition
                        id="id"
                        sortable={false}
                        title={formatMessage(uiMessages.tableManage)}
                        customComponent={this.Actions} />
                </RowDefinition>
            </TypedTable>
        );
    }
}

export { UserTable, UserTableProps };
